import { TutorialDefinition, TutorialScene } from '../TutorialEngine.js';
import { COLORS } from '../../rendering/Renderer.js';
import { CrossingVortexTutorialState } from './CrossingTutorialAdapter.js';

type VState = CrossingVortexTutorialState;

const PARTIAL = 'C5F5,E3F3';
const PARTIAL_GATED = `${PARTIAL}|E1=D4`;
const SOLVED = 'D3C3,B3B1,E2E3,C5F5,A2C2|E1=D4';

const scenes: TutorialScene[] = [
    // Scene 1: Toggle Gates — animate the gate placement flow
    {
        gameState: { crossing: PARTIAL } as VState,
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Click Activate Vortex\nto place a gate pair', cell: 'C2', anchor: 'center' },
            { type: 'text-label', text: 'Pair must be linked\nin the Vortex Hub', cell: 'B5', anchor: 'center' },
        ],
        animate: {
            interval: 1500,
            loop: true,
            frames: [
                { crossing: PARTIAL },
                { crossing: PARTIAL, gateMode: true },
                { crossing: PARTIAL_GATED, gateMode: true },
                { crossing: PARTIAL_GATED },
            ] as VState[],
        },
    },

    // Scene 2: Activation — toggle an unblocked pair active; a blocked pair stays amber
    {
        gameState: { crossing: 'B5A5', gateMode: true, extraGates: [['B5', 'D5']] } as VState,
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Click a pair\nto activate it', cell: 'D3', anchor: 'center', color: COLORS.teal },
            { type: 'text-label', text: 'Teleporters block\ngate activation', cell: 'B5', anchor: 'far-above', color: COLORS.amber },
        ],
        animate: {
            interval: 1500,
            loop: true,
            frames: [
                { crossing: 'B5A5', gateMode: true, extraGates: [['B5', 'D5']] },
                { crossing: 'B5A5|E1=D4', gateMode: true, extraGates: [['B5', 'D5']] },
            ] as VState[],
        },
    },

    // Scene 3: Ball teleportation
    {
        gameState: { crossing: `${PARTIAL_GATED}+D1` } as VState,
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'A ball enters\na gate...', cell: 'E0', anchor: 'far-left' },
            { type: 'text-label', text: '...exits from\nthe other side', cell: 'C5', anchor: 'far-right' },
            { type: 'pulse', cell: 'E1', color: COLORS.purple },
            { type: 'pulse', cell: 'D4', color: COLORS.purple },
        ],
    },

    // Scene 4: Full solved state
    {
        gameState: { crossing: SOLVED } as VState,
        renderOptions: {},
        annotations: [
            { type: 'text-label', text: 'Gates work in\nboth directions', cell: 'C0', anchor: 'center', color: COLORS.amber },
            { type: 'pulse', cell: 'E1', color: COLORS.purple },
            { type: 'pulse', cell: 'D4', color: COLORS.purple },
        ],
    },
];

/**
 * Vortex Crossing tutorial: 4 scenes on a 6×6 vortex grid with digits 0-3.
 * Teaches ball teleportation through Vortex gates.
 */
export const CROSSING_VORTEX_TUTORIAL: TutorialDefinition = {
    gameType: 'crossing-vortex',
    gridCode: '6/0-3:0C4,1F2,2A3,3D1',
    scenes,
    previewScene: 3,
};
